import {css} from "@emotion/css";
import {grey} from "@mui/material/colors";
import thermalSvg from "../elevationTool/scenes/export/beadProfiles/thermal.svg?raw";
import snapInSvg from "../elevationTool/scenes/export/beadProfiles/snap-in.svg?raw";
import screwInSvg from "../elevationTool/scenes/export/beadProfiles/screw-in.svg?raw";

// the line drawing per bead, keyed by the stored bead value the API reports as beadKey
// (drw.beadKey). Imported as raw markup rather than a URL so the drawing is inline in the page:
// the PDF is produced by serializing the rendered DOM and posting the HTML, which carries no
// relative asset references (see PDFGenerator).
const beadProfiles: {[key: string]: {label: string; svg: string}} = {
    "thermal": {label: "Thermal", svg: inlineSvg(thermalSvg)},
    "snapIn": {label: "Snap-in", svg: inlineSvg(snapInSvg)},
    "screwIn": {label: "Screw-in", svg: inlineSvg(screwInSvg)},
};

// drop the file's XML declaration: an HTML parser reads it as a bogus comment, which would then
// ride along into the serialized PDF markup.
function inlineSvg(source: string): string {
    return source.replace(/^\s*<\?xml[^>]*\?>\s*/, "");
}

// the drawings sit at a common width; each keeps its own aspect ratio off its viewBox.
const drawing = css({
    "& svg": {
        width: 110,
        height: "auto",
        display: "block",
    },
});

// the bead profiles used by one section's glass: the cross-section drawing of each bead the
// section's Bead column names, so the drawing beside the table shows how the glass is held in.
// Renders nothing when no bead in the section has a drawing.
export function BeadProfiles(props: {
    beadKeys: string[];
}) {
    const keys = props.beadKeys.filter((key, index) =>
        props.beadKeys.indexOf(key) === index && !!beadProfiles[key]);

    if(keys.length === 0) return null;

    return (
        <>
            <div style={{fontWeight: "bold", fontSize: "0.7rem", paddingBottom: 4}}>Bead Profiles</div>
            <div style={{display: "flex", flexDirection: "row", gap: 16, flexWrap: "wrap"}}>
                {keys.map(key => (
                    <div key={key} style={{display: "flex", flexDirection: "column", alignItems: "center"}}>
                        <div
                            className={drawing}
                            style={{
                                border: "1px solid " + grey["300"],
                                padding: 6,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                            }}
                            dangerouslySetInnerHTML={{__html: beadProfiles[key].svg}}
                        />
                        <div style={{fontSize: "0.6rem", paddingTop: 2}}>{beadProfiles[key].label}</div>
                    </div>
                ))}
            </div>
        </>
    );
}
